import { render, staticRenderFns } from "./projectPic.vue?vue&type=template&id=4cd776fc"
import script from "./projectPic.vue?vue&type=script&lang=js"
export * from "./projectPic.vue?vue&type=script&lang=js"
import style0 from "./projectPic.vue?vue&type=style&index=0&id=4cd776fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports